export const WHY_GOUSTO = {
  altText:
    'Table served with Salmon Tacos and fresh coleslaw salad, Mango and coconut dhal With Fluffy Rice and Spring vegetables gnocchi in a creamy lemon and cheese sauce',
  ctaText: 'Claim 50% off today',
}
